export class AddressSuggestion {
	address: string;
	latitude: number;
	longitude: number;
	constructor(address: string) {
		this.address = address;
	}
}
